export default __webpack_public_path__ + "static/media/about_us_after.9bdab485.png";